import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import "./app.css";
import Providers from "./providers";
import { Router } from "./router";

const apiUrl = import.meta.env.VITE_API_URL;

if (!apiUrl) {
  throw new Error("VITE_API_URL is not set");
}

Sentry.init({
  dsn: "https://09f7f8a3a7a8febf1f8da51bdb385b1f@o4510389702950912.ingest.us.sentry.io/4510393763627008",
  sendDefaultPii: true,
  integrations: [
    Sentry.consoleLoggingIntegration({
      levels: ["log", "info", "warn", "error"],
    }),
    Sentry.browserTracingIntegration(),
  ],
  tracesSampleRate: 1.0,
  tracePropagationTargets: [apiUrl],
  enableLogs: true,
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Providers>
      <Router />
    </Providers>
  </StrictMode>
);
